<template>
  <single-dish
    :selection="selection"
    :disabled="disabled"
    :opaque="opaque || !canAffordDish"
    :hide-price="hidePrice"
    :dishes-in-cart="dishesInCart"
    :dishes-in-order="dishesInOrder"
    :can-afford-dish="canAffordDish"
    @oncontextmenu="(e) => $emit('oncontextmenu', e, selection)"
    @click.native="() => !disabled && canAffordDish && $emit('addSelection', selection)"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import SingleDish from './dish-card/SingleDish.vue';

export default {
  name: 'DishItem',
  components: {
    'single-dish': SingleDish,
  },
  props: {
    selection: {
      type: Object,
      default: undefined,
    },
    disabled: Boolean,
    dishesInCart: {
      type: Number,
      default: 0,
    },
    dishesInOrder: {
      type: Number,
      default: 0,
    },
    hidePrice: Boolean,
    opaque: Boolean,
    canAffordDish: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('colorStore', ['items']),
  },
  methods: {
    addSelection(selection) {
      this.$emit('addSelection', selection);
    },
  },
};
</script>
